import { useEffect, useState } from "react";

import { useProxy } from "./use-proxy";

export const useJumpUrl = (target, { lazy = false } = {}) => {
  console.warn(
    "[DEPRECATED]",
    "`useJumpUrl` is deprecated and will be removed in the future version. Please switch to `useProxy`"
  );

  const { createJumpUrl } = useProxy();

  const [loading, setLoading] = useState(true);
  const [loaded, setLoaded] = useState(false);

  const fetch = () => {
    setLoading(false);
    setLoaded(true);
  };

  useEffect(() => {
    if (lazy) {
      return;
    }

    fetch();
  }, [lazy]);

  return {
    loading,
    loaded,
    error: null,
    url: loading ? null : createJumpUrl(target),
    fetch
  };
};
